import { useAppSelector } from '@/hooks/useRedux'
import { appSelector } from '@/pages/home/selectors'
import { ReactNode } from 'react'
import { useMediaQuery } from 'usehooks-ts'
import GoogleAd from '../sidebar/GoogleAd'

export const MainContent = ({ children, isShowFilter }: { children: ReactNode; isShowFilter?: boolean }) => {
  const { isShowMenu, isGoogleAdsRollout } = useAppSelector(appSelector)

  const isMobile = useMediaQuery('(max-width: 767px)')

  return (
    <div
      className={`transition-all duration-500 ease-in-out
        ${isShowMenu && 'lg:ml-56 2xl:ml-72'} ${isShowFilter && 'lg:mr-[250px] xl:mr-[296px] 2xl:mr-[364px]'}`}
    >
      {isGoogleAdsRollout && isMobile && (
        <div id="google-ads" className="w-full h-[100px]">
          <div className="w-full">
            <GoogleAd slot="3658392645" format="" style={{ display: 'inline-block', width: '370px', height: '90px' }} />
          </div>
        </div>
      )}
      <div className="max-w-[964px] mx-auto">{children}</div>
    </div>
  )
}
